export default __webpack_public_path__ + "images/76566b7779c692ae8e3c785ce7fda73f-beauty.jpg";